export default "__VITE_ASSET__BnORVP14__"